<template>
    <div class="ScenePixi"></div>
</template>

<script>

import { Application, Container, Graphics, Sprite } from 'pixi.js'

export default {

    name: 'ScenePixi',

    beforeDestroy() {
        if(this.$rafID){
            cancelAnimationFrame(this.$rafID)
        }
        if(this.$pixi) {
            this.$pixi.destroy()
        }  
    },

    created() {

        this.$coef = this.$parent.$coef
        this.$debug = this.$parent.$debug
        this.$events = new PIXI.utils.EventEmitter()
        this.$parent.$events = this.$events 
        this.$animateTimer = 0
        this.$coef_video = this.$parent.$coef_video
        this.$width = this.$parent.$width
        this.$height = this.$parent.$height
    },

    mounted() {

        if(!this.$debug)  {

            this.animate()
            this.initPixi()
        }
    },

    methods: {

        initPixi() {

            this.$pixi = new PIXI.Application(this.$width, this.$height, {
                antialias: true,
                resolution: window.devicePixelRatio,
                transparent: true,
                forceCanvas: true,

                view: this.$parent.$refs.canvas
            })

            this.$videoground = new PIXI.Container()
            this.$blackground = new PIXI.Container()
            this.$champagne = new PIXI.Container()
            this.$background = new PIXI.Container()
            this.$foreground = new PIXI.Container()
            this.$container_petals = new PIXI.Container()
            this.$container_ruban = new PIXI.Container()

            this.$pixi.stage.addChild(this.$videoground)
            this.$pixi.stage.addChild(this.$blackground)
            this.$pixi.stage.addChild(this.$champagne)
            this.$pixi.stage.addChild(this.$container_petals)
            this.$pixi.stage.addChild(this.$background)
            
            this.$pixi.stage.addChild(this.$container_ruban)
            this.$pixi.stage.addChild(this.$foreground)

            let graphics = new PIXI.Graphics()
                graphics.beginFill(0x000000, 1)
                graphics.drawRect(0, 0, 2000, 2000)
                graphics.endFill()

            const texture = graphics.generateCanvasTexture()
            this.$black = new PIXI.Sprite(texture)
            this.$blackground.addChild(this.$black)

            this.$parent.$pixi = this.$pixi
            this.$parent.$blackground = this.$blackground
            this.$parent.$videoground = this.$videoground
            this.$parent.$champagne = this.$champagne
            this.$parent.$background = this.$background
            this.$parent.$foreground = this.$foreground
            this.$parent.$container_petals = this.$container_petals
            this.$parent.$container_ruban = this.$container_ruban
            this.$parent.$blackground = this.$blackground
            this.$parent.$black = this.$black
        },

        addVideoToCanvas(video) {
            this.$video = video
            const texture = PIXI.Texture.fromVideo(this.$video)
            const sprite = new PIXI.Sprite(texture)
            sprite.scale.set(this.$coef_video)
            this.$videoground.addChild(sprite)
            this.$videoground.scale.set(-1, 1)
            this.$videoground.position.x += this.$width
        },

        animate(delta) {

            this.rafID = requestAnimationFrame(this.animate)
            if(!this.$debug) {
                this.$animateTimer += delta
                this.$events.emit('animate', delta, this.$animateTimer)
            }
        },

    }
}
</script>














